import React, { useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import {FOREFLIGHT_BLUE} from "../styledComponents";

const StyledButton = styled(Button)({
    backgroundColor: FOREFLIGHT_BLUE,
    color: 'white',
    height: '35px',
    marginTop: '20px',
    textTransform: 'none',
    borderRadius: '2px',

    '&:hover': {
        backgroundColor: '#2a3f55',
    },
    '&.Mui-disabled': {
        backgroundColor: '#193e5d !important',
        color: 'rgba(255, 255, 255, 0.5)',
    },
    '& .MuiCircularProgress-root': {
        color: 'white', // <-- spinner color
    },
});

const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '600px',
    margin: '0 auto',
    padding: '32px 16px',
});

const Title = styled(Typography)({
    fontSize: '24px',
    fontWeight: 600,
    color: '#ffffff',
    marginBottom: '24px',
});

const Message = styled(Typography)({
    fontSize: '16px',
    color: '#b0b0b0',
    lineHeight: '1.6',
    marginBottom: '24px',
});

const BottomMessage = styled(Typography)({
    fontSize: '14px',
    color: '#b0b0b0',
    lineHeight: '1.5',
    marginTop: '24px',
});

interface Props {
    show: boolean;
    onContinue: () => void;
    onCancel: () => void;
    ffResetUrl: string;
}

const SyncWarning = ({ show, onContinue, onCancel, ffResetUrl }: Props) => {
    const [isChecked, setIsChecked] = useState(false);

    if (!show) {
        return <></>;
    }

    return (
        <Container>
            <Title>Password Sync Warning</Title>

            <Message>
                Your JDM credentials are currently in sync with your ForeFlight account.
                Resetting will require you to use separate passwords for JDM and ForeFlight moving forward.
            </Message>

            <StyledButton
                    fullWidth
                    variant="contained"
                    type="submit"
                    onClick={onContinue}
            >
                Reset My JDM Password
            </StyledButton>

            <BottomMessage>
                To keep passwords synced, use{' '}
                <Link href={ffResetUrl} sx={{ color: '#00a8e1', textDecoration: 'underline' }}>
                    ForeFlight password reset
                </Link>{' '}
                instead.
            </BottomMessage>
        </Container>
    );
};

export default SyncWarning;
